"use client";

import { Formik, Form, Field } from "formik";
import debounce from "lodash.debounce";
import { useEffect, useMemo, useState } from "react";
import { Filter, X } from "lucide-react";
import "./UniversalFilterPanel.css";

export type FilterField =
  | {
      name: string;
      label: string;
      type: "select";
      options: { value: string; label: string }[];
    }
  | {
      name: string;
      label: string;
      type: "select-api";
      source: string;
    };

type Props = {
  fields: FilterField[];
  initialValues?: Record<string, string>;
  onFilterChange: (values: Record<string, string>) => void;

  dataSources?: Record<string, { value: string; label: string }[]>;
};

const UniversalFilterPanel = ({
  fields,
  initialValues = {},
  onFilterChange,
  dataSources = {},
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const debouncedFilter = useMemo(
    () =>
      debounce((values: Record<string, string>) => {
        onFilterChange(values);
      }, 300),
    [onFilterChange]
  );

  useEffect(() => {
    return () => debouncedFilter.cancel();
  }, [debouncedFilter]);

  return (
    <div className="universal-filter-wrapper">
      <button
        className="filter-toggle-button"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        {isOpen ? <Filter size={20} /> : <Filter size={20} />}
        {/* <span>Filters</span> */}
      </button>

      {isOpen && (
        <div className="universal-filter-panel">
          <Formik
            initialValues={initialValues}
            onSubmit={() => {}}
            validate={(values) => {
              debouncedFilter(values);
              return {};
            }}
          >
            {() => (
              <Form className="universal-filter-form">
                {fields.map((field) => {
                  let options: { value: string; label: string }[] = [];

                  if (field.type === "select") {
                    options = field.options;
                  } else if (field.type === "select-api") {
                    options = dataSources[field.source] || [];
                  }

                  return (
                    <Field
                      key={field.name}
                      as="select"
                      name={field.name}
                      className="universal-filter-select"
                    >
                      <option value="">{field.label}</option>
                      {options.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                          {opt.label}
                        </option>
                      ))}
                    </Field>
                  );
                })}
              </Form>
            )}
          </Formik>
        </div>
      )}
    </div>
  );
};

export default UniversalFilterPanel;
